import { createModal } from '/@/core/elements/modal'
import {
  type ProjectThing,
  type ProjectThingType,
} from '/@/common/things/types'
import type { ProductInfo } from '/@/common/ImportProduct'

interface SubmitData {
  things: ProjectThing[]
}
interface AddThingToProjectModalData {
  type?: ProjectThingType | null
  projectId: string
  projectName: string
  sectionId?: string | null
  sectionName?: string | null
  thingTypes?: ProjectThingType[] | null
  state?: 'initial' | 'input'
  productInfo?: ProductInfo | null
  onBack?: () => void
  onSubmit: (data: SubmitData) => void
}

const { api, component } = createModal<AddThingToProjectModalData>(
  'AddThingToProjectModal',
  () => import('./AddThingToProjectModal.vue'),
  {
    type: null,
    projectId: '',
    projectName: '',
    sectionId: null,
    sectionName: null,
    thingTypes: null,
    productInfo: null,
    onBack: () => undefined,
    onSubmit: () => undefined,
  },
)

export const useAddThingToProjectModal = api
export default component
